import styled from 'styled-components';

export const Wrapper = styled.div`
  flex: 1;
  padding: 0 20px;
  display: flex;
  flex-direction: column;
  min-height: calc(100vh - 80px);
`;

export const Content = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 20px;
`;

export const Preview = styled.div`
  position: absolute;
  top: 256px;
  left: 525px;
  width: 255px;
  height: 210px;
  background-color: #000;
  display: flex;
`;
